// extracted by mini-css-extract-plugin
export default {"form":"form__-2300af42","row":"row__-2300af42","buttonGroup":"buttonGroup__-2300af42","btn":"btn__-2300af42","save":"save__-2300af42","cancel":"cancel__-2300af42"};